import type { DateTime } from "luxon";

// The removal step's two gates (P3-3), pure so they can be pinned on their own. Both are the rules an existing surface
// applies: the desktop dialog's own validity, the "Other needs words" requirement, and the classic mobile screen's
// confirm for a removal far out.

/** What the removal step's confirm is gated on, read off the wrapped removal state. */
export type RemovalGateInput = {
	/** The step shows the reason picker (not a self-scheduling or hospital removal, which record their own). */
	showsReasons: boolean;
	selectedReason: string | undefined;
	/** The picked reason is the department's "Other". */
	isOther: boolean;
	removalMessage: string;
	/** The wrapped hook's own validity — the payroll acknowledgement for a single removal that needs one. */
	deleteValid: boolean | undefined;
	isLoading: boolean;
};

/**
 * Whether the removal can be confirmed: a reason when the step asks for one, and words with "Other" (P3-3 — the
 * reason saved is "Other" and the text is the removal message, P3-15); the wrapped hook's own validity; nothing in
 * flight.
 */
export const canConfirmRemoval = ({ showsReasons, selectedReason, isOther, removalMessage, deleteValid, isLoading }: RemovalGateInput): boolean => {
	const isReasonReady = !showsReasons || (selectedReason !== undefined && (!isOther || removalMessage.trim().length > 0));
	return isReasonReady && deleteValid === true && !isLoading;
};

/** Whole days from now until the shift starts — what the far-out confirm counts and names. */
export const removalDaysOut = (shiftStart: DateTime, now: DateTime): number => Math.floor(shiftStart.diff(now, "days").days);

/**
 * Whether the removal asks twice first: a shift at least `thresholdDays` out (`REMOVE_NURSE_DAYS_THRESHOLD`, the
 * classic mobile screen's own rule) — removing someone that far ahead is rarely a call-in.
 */
export const needsFarOutConfirm = (daysOut: number, thresholdDays: number): boolean => daysOut >= thresholdDays;
